module.exports = __webpack_public_path__ + "7282c55404bf70644bdb2e41bc93417d.svg";